<template>
  <div class="aa">
    <table>
      <thead>
        <tr class="tr-title">
            <th class="td-title">尊姓大名</th>
            <th class="td-title">花费</th>
            <th class="td-title" v-on:click="hideAd=!hideAd">删除</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(person,index) in costs">
          <td class="td-name">{{ person.name }}</td>
          <!-- <td class="td-cost"><input v-model="person.cost" type="number" pattern="[0-9]+([\s]+[0-9]+)?"/></td> -->
          <td class="td-cost"><input v-model="person.cost" placeholder="多个数字可以用空格隔开，例如： 1  2.5  10"/></td>
          <td>
            <a class="btn-floating btn-small waves-effect waves-light red" v-on:click="removePerson(index)"><i class="material-icons"> - </i></a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="buttons">
      <button class="waves-effect waves-light btn my-btn" v-on:click="addPerson()">+ 加人</button>
      <button class="waves-effect waves-light btn my-btn" v-on:click="performAA()">AA一下</button>
    </div>

    <div v-bind:class="{result: hideResult}">
      <h5>计算结果</h5>
      <ul class="collection list-result">
        <li class="collection-item" v-for="record in aa_result">
          {{record.from}} 给 {{ record.to }} {{record.amount | formatNumber}}
        </li>
      </ul>
      <p>平均每人花费: {{ average | formatNumber }}</p>
      <button class="waves-effect waves-light btn red clear-btn" v-on:click="hideResult=true">清除结果</button>
    </div>

    <div v-bind:class="{result: hideAd}">
      <p class="list-result">被你发现了！这个app还有无良广告……既然被你看到了，就请帮忙点一下吧</p>
      <p class="list-result">按一下右上角的“删除”，可以去掉下面的无良广告。</p>
        <!-- Begin BidVertiser code -->
        <SCRIPT data-cfasync="false" SRC="//bdv.bidvertiser.com/BidVertiser.dbm?pid=671350&bid=1739253" TYPE="text/javascript"></SCRIPT>
        <!-- End BidVertiser code --> 
    </div>
  </div>
</template>

<script>
import AACalculator from "../assets/AACalc";

//var numeral = require("numeral");


export default {
  name: 'HelloWorld',
  data () {
    return {
      costs: [
        {name: "Peter", cost: 5},
        {name: "Tom", cost: 3},
        {name: "Lucy", cost: 15},
        {name: "Jack", cost: 1},
      ],
      hideResult: true,
      aa_result: [],
      average: 0,
      hideAd: true
    }
  },

  created: function() {
    var aa_costs = this.$localStorage.get('aa_costs');
    // console.log(aa_costs);
    
    this.aa = new AACalculator();
    if (aa_costs != null) {
      this.aa.costs = JSON.parse(aa_costs);
    }
    this.costs = this.aa.costs;
    this.aa_result = [];
  },

  methods: {
    addPerson: function() {
      var name = prompt("请输入尊姓大名");
      if (name != null && name != "null" && name.length > 0) {
        this.aa.addName(name);
      }
    },

    removePerson: function(index) {
      this.costs.splice(index, 1);
    },

    performAA: function() {
      this.aa_result = this.aa.computeAAResult();
      this.average = this.aa.getAverageCost();
      this.hideResult = false;
      this.$localStorage.set('aa_costs', JSON.stringify(this.aa.costs));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tr-title {
    background-color: #cc0000;
    color: white;
    text-shadow: 2px 2px 8px #eeeeee;
  }

  .td-title {
    text-align: center;
  }

  .td-name {
    width: 20%;
    text-align: center;
  }

  .td-cost {
    width: 68%;
    padding-left: 5%;
    padding-right: 5%;
  }

  .my-btn {
    width: 40%;
    margin-right: 2%;
    margin-top: 10px;
  }

  .result {
    display: none;
  }

  .list-result {
    text-align: left;
    margin-left: 3%;
    margin-right: 3%
  }

  .clear-btn {
    margin-bottom: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue